import React, { useEffect, useState } from "react";
import { Container, Modal } from "react-bootstrap";
import styleClasses from "../try2.module.scss";
import "swiper/swiper.scss";
import "swiper/modules/navigation/navigation.scss";
import OtherDressing from "./try2Customization/OtherDressing";
import { IAddToCombo, IModifiersObjects } from "../../../models/try2Combo";
import Sliders from "./try2Customization/Sliders";
import ApplyButton from "./try2Customization/ApplyButton";
import { useDispatch } from "react-redux";
import { removeTemporarilyAddedPriceForItem } from "../../../redux/slices/itemCustomizationSlice";
import { REQUIRED_MODIFIERS } from "../../../constants";
import { itemBuckets } from "../../../priceCalculation/buckets";
import { ADDITIONAL_ADDED } from "../../../priceCalculation/constants";
import styles from '../../../components/OrderAnItem/ItemCustomization/UpSellModifierGroup/UpSellModifierGroup.module.scss'


const AddToCombo: React.FunctionComponent<IAddToCombo> = ({
  showCustomizationModal,
  closeCustomizationModal,
  requiredModifierGroups,
  handleIngredientSelection,
  addItemtoCombo,
  sectionSelected,
  isShowingRequiredModalOnCustomization,
  noDressingHandler,
  otherDreesingState,
  isInItemPresentState,
  cleaningForRequiredModifiers,
  selectedItem,
  showProteinModalOnCombo,
  isSaladFirstSelection,
  isAddOnOrDoubleProtein
}) => {
  const dispatch = useDispatch();

  const {getOrderButtonState} = useApplyButtonState();

  const { otherDressingData, setOtherDressingData } = otherDreesingState;
  const { isInItemPresent, setIsInItemPresent } = isInItemPresentState;
  const [selectedOtherDressingData, setSelectedOtherDressingData] = useState<
    IModifiersObjects[]
  >([]);

  useEffect(() => {
    if (requiredModifierGroups && requiredModifierGroups.length > 0) {
      const modifiers =
        requiredModifierGroups[0]?.required_modifiers_groups_modifiers;
      const inItemFlag = modifiers?.filter((modifier) => modifier.in_item);
      inItemFlag?.length > 0
        ? setIsInItemPresent(true)
        : setIsInItemPresent(false);
    }
  }, [requiredModifierGroups, showCustomizationModal]);

  const updateSelectedModifiers = (modifier) => {
    updateSelectedOtherDressingData(modifier);
    handleIngredientSelection(modifier);
  };

  const updateSelectedOtherDressingData = (modifier) => {
    const index = selectedOtherDressingData?.findIndex(
      (selectedModifier) =>
        selectedModifier.modifier_id === modifier.modifier_id
    );
    if (index !== -1) {
      selectedOtherDressingData[index] = modifier;
      setSelectedOtherDressingData([...selectedOtherDressingData]);
    } else {
      setSelectedOtherDressingData([...selectedOtherDressingData, modifier]);
    }
  };

  const removeSelectedIngredients = () => {
    // itemBuckets.discardBucketChanges(sectionSelected)
    dispatch(
      removeTemporarilyAddedPriceForItem({
        price: itemBuckets.discardBucketChanges(sectionSelected),
        item: sectionSelected,
      })
    );

    // dispatch(removeTry2ComboIngredients({modifiers:selectedOtherDressingData,sectionSelected}))
    setSelectedOtherDressingData([]);
  };

  const addSelectedIngredients = () => {
    if (!isShowingRequiredModalOnCustomization) {
      setOtherDressingData(false);
      setSelectedOtherDressingData([]);
    }
    addItemtoCombo();
  };

  const closeModal = () => {
    cleaningForRequiredModifiers();
    closeCustomizationModal();
  };

  const otherDressingHandler = () => {
    itemBuckets.createBucketCopy();
    setOtherDressingData(true);
  };

  const selectedIngredients = (function () {
    return itemBuckets.specificItemBucketSelectedModifiers(
      REQUIRED_MODIFIERS,
      sectionSelected
    );
  })();

  const selectedAddedIngredients = (function () {
    const fromItem: any = parseInt(sectionSelected) - 1;
    return itemBuckets.getSingleBucketKeyValue({
      name: REQUIRED_MODIFIERS,
      fromItem,
      modifierType: ADDITIONAL_ADDED,
      key: "modifiers",
    });
  })();

  const noDressingModifiers = (function () {
    const requiredModifiersBucket = itemBuckets.getSingleBucket({
      name: REQUIRED_MODIFIERS,
      fromItem: parseInt(sectionSelected),
    });
    return requiredModifiersBucket?.noDressingModifiers;
  })();

  const sorted = (required_modifiers_groups_modifiers) => {
    // Remove quantity keyword
    for (let i = 0; i < required_modifiers_groups_modifiers.length; i++) {
      if (required_modifiers_groups_modifiers[i].quantity) {
        delete required_modifiers_groups_modifiers[i].quantity;
      }
    }
    // Add selected quantity to modifier
    for (let i = 0; i < required_modifiers_groups_modifiers.length; i++) {
      for (let j = 0; j < selectedIngredients.length; j++) {
        if (!required_modifiers_groups_modifiers[i].quantity) {
          if (
            required_modifiers_groups_modifiers[i].id ===
            selectedIngredients[j].modifier_id
          ) {
            required_modifiers_groups_modifiers[i].quantity =
              selectedIngredients[j].quantity;
          } else {
            required_modifiers_groups_modifiers[i].quantity = 0;
          }
        }
      }
    }
    required_modifiers_groups_modifiers.sort((a, b) => {
      return b.quantity - a.quantity;
    });
  };

  let items_required_modifier_groups =
    requiredModifierGroups &&
    requiredModifierGroups.length > 0 &&
    requiredModifierGroups[0];

  return (
    <Modal
      show={showCustomizationModal}
      onHide={closeModal}
      centered
      className={`${
        otherDressingData && "other-dressings-modal"
      } theme-modal-style app_container_wrap no-padding border-radius-15 border-radius-sm-12 upperside-radius-sm-only try2_dressing_modal`}
    >
      <Modal.Header className="pt-0" id="close_button2">
        <button
          type="button"
          className="btn modal-close-button pe-0 sm-blue-icon"
          onClick={closeModal}
        >
          Close
        </button>
      </Modal.Header>
      <Modal.Body
        className={`${
          otherDressingData && "pe-3 pe-md-0"
        } app_container_wrap px-2 px-md-0 text-center`}
      >
        <div
          className={`${styleClasses.items_wrap} ${
            !otherDressingData && "mb-4 mb-sm-3 pb-5 pb-md-0"
          } ${styleClasses.select_dressing_wrapper}`}
        >
          {otherDressingData ? (
            <>
              <OtherDressing
                items_required_modifier_groups={requiredModifierGroups}
                setOtherDressingData={() => {
                  // removeSelectedIngredients();
                  sorted(
                    requiredModifierGroups[0]
                      .required_modifiers_groups_modifiers
                  );
                  setOtherDressingData(false);
                }}
                otherDressingHandler={otherDressingHandler}
                noDressingHandler={noDressingHandler}
                selectedIngredients={selectedIngredients}
                selectedAddedIngredients={selectedAddedIngredients}
                handleIngredientSelection={(data) =>
                  updateSelectedModifiers(data)
                }
                sectionSelected={sectionSelected}
                selectedOtherDressingData={selectedOtherDressingData}
                addSelectedIngredients={addSelectedIngredients}
                label={items_required_modifier_groups?.label}
                getOrderButtonState={() => getOrderButtonState({selectedItem, sectionSelected})}
              />
            </>
          ) : (
            <>
               <Sliders
                items_required_modifier_groups={requiredModifierGroups}
                otherDressingHandler={otherDressingHandler}
                selectedIngredients={selectedIngredients}
                handleIngredientSelection={handleIngredientSelection}
                setOtherDressingData={() => setOtherDressingData(false)}
                selectedAddedIngredients={selectedAddedIngredients}
                isInItemPresent={isInItemPresent}
                sectionSelected={sectionSelected}
                noDressingHandler={noDressingHandler}
                noDressingModifiers={noDressingModifiers}
                addItemtoCombo={addItemtoCombo}
                addSelectedIngredients={addSelectedIngredients}
                selectedItem={selectedItem}
                showProteinModalOnCombo={showProteinModalOnCombo}
                label={items_required_modifier_groups?.label}
                isSaladFirstSelection={isSaladFirstSelection}
                try2comboUpsellStyles= {styles.try2comboUpsellStyles}
                isShowingRequiredModalOnCustomization={isShowingRequiredModalOnCustomization}
                isAddOnOrDoubleProtein={isAddOnOrDoubleProtein}
                getOrderButtonState={() => getOrderButtonState({selectedItem, sectionSelected})}
              />
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

const useApplyButtonState = () => {
  const addSelectedModifiers = (selectedModifier,commulativeItems):void => {
    selectedModifier?.modifiers.forEach(element => {
      const index = commulativeItems.findIndex(e=> e.groupId === element?.modifier_group_id)
      if(index !== -1){
        commulativeItems[index].quantity = commulativeItems[index].quantity + element?.quantity
        commulativeItems[index].noDressing = false
      }else{
        const trackObj ={
          groupId: element?.modifier_group_id,
          quantity: element?.quantity,
          noDressing: false
        }
        commulativeItems.push(trackObj)
      }
    });
  }

  const addNoDressings = (selectedModifier,commulativeItems):void => {
    selectedModifier?.noDressings.forEach(element => {
      const index = commulativeItems.findIndex(e=> e.groupId === element?.id)
      if(index === -1){
        const trackObj ={
          groupId: element?.id,
          quantity: 0,
          noDressing: element?.noDressing
        }
        commulativeItems.push(trackObj)
      }else{
        commulativeItems[index].noDressing = element?.noDressing
      }
    })
  }
  
  const getOrderButtonState = ({selectedItem, sectionSelected}): boolean => {
    const requiredModifiers = selectedItem?.items_required_modifier_groups;
    if(requiredModifiers){
      const selectedModifier = itemBuckets.getSingleBucket(
      {name:REQUIRED_MODIFIERS,
      fromItem:parseInt(sectionSelected)}
    );
    const commulativeItems = []
    if(!requiredModifiers.length){
      return false;
    }
    addSelectedModifiers(selectedModifier,commulativeItems)
      
    if(selectedModifier?.noDressings){
      addNoDressings(selectedModifier,commulativeItems)
    }

      let isMinExeceeded = null;
      for (let i = 0 ; i < requiredModifiers.length ; i++ ){
        const itemIndex = commulativeItems.findIndex(e => e.groupId === requiredModifiers[i].id)
        const minReached = commulativeItems[itemIndex]?.noDressing === false ? commulativeItems[itemIndex]?.quantity > 0 && commulativeItems[itemIndex]?.quantity >=  requiredModifiers[i].min  : true
        if(itemIndex === -1 ||  !minReached){
          isMinExeceeded = false
          break;
        }
        else{
          isMinExeceeded = true
        }
      }
      if(isMinExeceeded){
        return false
      }else{
        return true
      }
    }else{
      return true
    }
  };

  return {getOrderButtonState};
}

export default AddToCombo;
